import styled from 'styled-components';
import { space, typography } from 'styled-system';

const P = styled.p`
${props => {
  if (props.size === 'xs') {
    return `
      font-size: 12px;
      line-height: 18px;
    `;
  }
  if (props.size === 's') {
    return `
      font-size: 14px;
      line-height: 20px;
    `;
  }
  if (props.size === 'm') {
    return `
      font-size: 16px;
      line-height: 24px;
    `;
  }
  if (props.size === 'l') {
    return `
      font-size: 18px;
      line-height: 28px;
    `;
  }
}}
  color: ${props => (props.muted ? '#6B6B6B' : props.theme.primary)};
  ${typography}
  ${space}

  &+p {
    margin-top: 12px;
  }
`;

P.defaultProps = {
  size: 'm',
};

export default P;
